// extracted by mini-css-extract-plugin
export default {"button":"back-button_button__9ppAp","text":"back-button_text__-6N2P","icon":"back-button_icon__YF+nJ"};